import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _serveBannersRequest = {};
var _serveBannersResponse = {};
function resolveWixDealerBannersApiV1DealerBannersServiceUrl(opts) {
    var domainToMappings = {
        'editor._base_domain_': [
            {
                srcPath: '/_serverless/dealer-banners-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_serverless/dealer-banners-service',
                destPath: '',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_serverless/dealer-banners-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_serverless/dealer-banners-service',
                destPath: '',
            },
        ],
        'cronulla-jobs._base_domain_': [
            {
                srcPath: '/serverless/dealer-banners-service',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_serverless/dealer-banners-service',
                destPath: '',
            },
        ],
        'create._base_domain_': [
            {
                srcPath: '/_serverless/dealer-banners-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Get all banners the user or site are eligible for.
 * placementId define the product location of the banners and is always required,
 */
export function serveBanners(payload) {
    return function __serveBanners(_a) {
        var host = _a.host;
        var toJSON = serializer(_serveBannersRequest, {}).toJSON;
        var fromJSON = serializer(_serveBannersResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixDealerBannersApiV1DealerBannersServiceUrl({
                protoPath: '/v1/banners/serve',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map